// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4427":"8f49d0eb","7941":"8f49d0eb"}[chunkId] + ".chunk.css";
};